import {createEntitySlice} from 'utils/createEntitySlice';
import {ProgramCard} from 'types/programCard';
import {ProgramCardsThunks} from 'features/programs/program/cards/programCardThunks';

export interface ProgramCardState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  programCards?: any;
  pagy?: any;
  programCard?: any;
  isEditing?: boolean;
  activeTab?: string;
}

const initialState: ProgramCardState = {
  status: 'idle',
  error: null,
  programCards: [],
  programCard: {name: '', enable: false},
  pagy: {},
  isEditing: false,
  activeTab: 'Cards',
};

const programCardSlice = createEntitySlice<ProgramCard>({
  name: 'Card',
  initialState,
  thunks: ProgramCardsThunks,
  entityKey: 'programCard',
  entitiesKey: 'programCards',
  reducers: {},
});

export const {
  setEntity: setProgramCard,
  setIsEditing,
  setActiveTab,
} = programCardSlice.actions;
export {initialState as programCardInitialState};
export default programCardSlice.reducer;
